export const ViewBaseConfig = Symbol.for('drizzle:ViewBaseConfig');
